/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Area Restrita API
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ChecklistDetailQueryResponse,
  ChecklistQueryResponse,
  CloneChecklistCommandBody,
  CloneChecklistCommandResponse,
  CreateChecklistCommandBody,
  CreateChecklistCommandResponse,
  GetChecklistsParams,
  SetDefaultChecklistCommandResponse,
  UpdateChecklistCommandBody,
  UpdateChecklistCommandResponse
} from '../../model';

import { instance } from '../../index';
import type { ErrorType, BodyType } from '../../index';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getChecklists = (
    params: GetChecklistsParams,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<ChecklistQueryResponse>(
      {url: `/api/v1/hang-tag/check-list`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetChecklistsQueryKey = (params: GetChecklistsParams,) => {
    return [`/api/v1/hang-tag/check-list`, ...(params ? [params]: [])] as const;
    }

    
export const getGetChecklistsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getChecklists>>, GetChecklistsParams['page']>, TError = ErrorType<unknown>>(params: GetChecklistsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getChecklists>>, TError, TData, Awaited<ReturnType<typeof getChecklists>>, QueryKey, GetChecklistsParams['page']>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChecklistsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChecklists>>, QueryKey, GetChecklistsParams['page']> = ({ signal, pageParam }) => getChecklists({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getChecklists>>, TError, TData, Awaited<ReturnType<typeof getChecklists>>, QueryKey, GetChecklistsParams['page']> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetChecklistsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getChecklists>>>
export type GetChecklistsInfiniteQueryError = ErrorType<unknown>


export function useGetChecklistsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getChecklists>>, GetChecklistsParams['page']>, TError = ErrorType<unknown>>(
 params: GetChecklistsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getChecklists>>, TError, TData, Awaited<ReturnType<typeof getChecklists>>, QueryKey, GetChecklistsParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChecklists>>,
          TError,
          Awaited<ReturnType<typeof getChecklists>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetChecklistsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getChecklists>>, GetChecklistsParams['page']>, TError = ErrorType<unknown>>(
 params: GetChecklistsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getChecklists>>, TError, TData, Awaited<ReturnType<typeof getChecklists>>, QueryKey, GetChecklistsParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChecklists>>,
          TError,
          Awaited<ReturnType<typeof getChecklists>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetChecklistsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getChecklists>>, GetChecklistsParams['page']>, TError = ErrorType<unknown>>(
 params: GetChecklistsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getChecklists>>, TError, TData, Awaited<ReturnType<typeof getChecklists>>, QueryKey, GetChecklistsParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetChecklistsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getChecklists>>, GetChecklistsParams['page']>, TError = ErrorType<unknown>>(
 params: GetChecklistsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getChecklists>>, TError, TData, Awaited<ReturnType<typeof getChecklists>>, QueryKey, GetChecklistsParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetChecklistsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetChecklistsQueryOptions = <TData = Awaited<ReturnType<typeof getChecklists>>, TError = ErrorType<unknown>>(params: GetChecklistsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChecklists>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChecklistsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChecklists>>> = ({ signal }) => getChecklists(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getChecklists>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetChecklistsQueryResult = NonNullable<Awaited<ReturnType<typeof getChecklists>>>
export type GetChecklistsQueryError = ErrorType<unknown>


export function useGetChecklists<TData = Awaited<ReturnType<typeof getChecklists>>, TError = ErrorType<unknown>>(
 params: GetChecklistsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChecklists>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChecklists>>,
          TError,
          Awaited<ReturnType<typeof getChecklists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetChecklists<TData = Awaited<ReturnType<typeof getChecklists>>, TError = ErrorType<unknown>>(
 params: GetChecklistsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChecklists>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChecklists>>,
          TError,
          Awaited<ReturnType<typeof getChecklists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetChecklists<TData = Awaited<ReturnType<typeof getChecklists>>, TError = ErrorType<unknown>>(
 params: GetChecklistsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChecklists>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetChecklists<TData = Awaited<ReturnType<typeof getChecklists>>, TError = ErrorType<unknown>>(
 params: GetChecklistsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChecklists>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetChecklistsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetChecklistsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getChecklists>>, TError = ErrorType<unknown>>(params: GetChecklistsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChecklists>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChecklistsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChecklists>>> = ({ signal }) => getChecklists(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChecklists>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetChecklistsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getChecklists>>>
export type GetChecklistsSuspenseQueryError = ErrorType<unknown>


export function useGetChecklistsSuspense<TData = Awaited<ReturnType<typeof getChecklists>>, TError = ErrorType<unknown>>(
 params: GetChecklistsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChecklists>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetChecklistsSuspense<TData = Awaited<ReturnType<typeof getChecklists>>, TError = ErrorType<unknown>>(
 params: GetChecklistsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChecklists>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetChecklistsSuspense<TData = Awaited<ReturnType<typeof getChecklists>>, TError = ErrorType<unknown>>(
 params: GetChecklistsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChecklists>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetChecklistsSuspense<TData = Awaited<ReturnType<typeof getChecklists>>, TError = ErrorType<unknown>>(
 params: GetChecklistsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChecklists>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetChecklistsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const createChecklist = (
    createChecklistCommandBody: BodyType<CreateChecklistCommandBody>,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<CreateChecklistCommandResponse>(
      {url: `/api/v1/hang-tag/check-list`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createChecklistCommandBody, signal
    },
      options);
    }
  


export const getCreateChecklistMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createChecklist>>, TError,{data: BodyType<CreateChecklistCommandBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof createChecklist>>, TError,{data: BodyType<CreateChecklistCommandBody>}, TContext> => {
    
const mutationKey = ['createChecklist'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createChecklist>>, {data: BodyType<CreateChecklistCommandBody>}> = (props) => {
          const {data} = props ?? {};

          return  createChecklist(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateChecklistMutationResult = NonNullable<Awaited<ReturnType<typeof createChecklist>>>
    export type CreateChecklistMutationBody = BodyType<CreateChecklistCommandBody>
    export type CreateChecklistMutationError = ErrorType<unknown>

    export const useCreateChecklist = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createChecklist>>, TError,{data: BodyType<CreateChecklistCommandBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof createChecklist>>,
        TError,
        {data: BodyType<CreateChecklistCommandBody>},
        TContext
      > => {

      const mutationOptions = getCreateChecklistMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getChecklist = (
    id: number,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<ChecklistDetailQueryResponse>(
      {url: `/api/v1/hang-tag/check-list/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetChecklistQueryKey = (id: number,) => {
    return [`/api/v1/hang-tag/check-list/${id}`] as const;
    }

    
export const getGetChecklistInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getChecklist>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getChecklist>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChecklistQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChecklist>>> = ({ signal }) => getChecklist(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getChecklist>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetChecklistInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getChecklist>>>
export type GetChecklistInfiniteQueryError = ErrorType<unknown>


export function useGetChecklistInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getChecklist>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getChecklist>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChecklist>>,
          TError,
          Awaited<ReturnType<typeof getChecklist>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetChecklistInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getChecklist>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getChecklist>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChecklist>>,
          TError,
          Awaited<ReturnType<typeof getChecklist>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetChecklistInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getChecklist>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getChecklist>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetChecklistInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getChecklist>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getChecklist>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetChecklistInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetChecklistQueryOptions = <TData = Awaited<ReturnType<typeof getChecklist>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChecklist>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChecklistQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChecklist>>> = ({ signal }) => getChecklist(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getChecklist>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetChecklistQueryResult = NonNullable<Awaited<ReturnType<typeof getChecklist>>>
export type GetChecklistQueryError = ErrorType<unknown>


export function useGetChecklist<TData = Awaited<ReturnType<typeof getChecklist>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChecklist>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChecklist>>,
          TError,
          Awaited<ReturnType<typeof getChecklist>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetChecklist<TData = Awaited<ReturnType<typeof getChecklist>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChecklist>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChecklist>>,
          TError,
          Awaited<ReturnType<typeof getChecklist>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetChecklist<TData = Awaited<ReturnType<typeof getChecklist>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChecklist>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetChecklist<TData = Awaited<ReturnType<typeof getChecklist>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChecklist>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetChecklistQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetChecklistSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getChecklist>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChecklist>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChecklistQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChecklist>>> = ({ signal }) => getChecklist(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChecklist>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetChecklistSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getChecklist>>>
export type GetChecklistSuspenseQueryError = ErrorType<unknown>


export function useGetChecklistSuspense<TData = Awaited<ReturnType<typeof getChecklist>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChecklist>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetChecklistSuspense<TData = Awaited<ReturnType<typeof getChecklist>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChecklist>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetChecklistSuspense<TData = Awaited<ReturnType<typeof getChecklist>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChecklist>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetChecklistSuspense<TData = Awaited<ReturnType<typeof getChecklist>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getChecklist>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetChecklistSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const updateChecklist = (
    id: number,
    updateChecklistCommandBody: BodyType<UpdateChecklistCommandBody>,
 options?: SecondParameter<typeof instance>,) => {
      
      
      return instance<UpdateChecklistCommandResponse>(
      {url: `/api/v1/hang-tag/check-list/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateChecklistCommandBody
    },
      options);
    }
  


export const getUpdateChecklistMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateChecklist>>, TError,{id: number;data: BodyType<UpdateChecklistCommandBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateChecklist>>, TError,{id: number;data: BodyType<UpdateChecklistCommandBody>}, TContext> => {
    
const mutationKey = ['updateChecklist'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateChecklist>>, {id: number;data: BodyType<UpdateChecklistCommandBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateChecklist(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateChecklistMutationResult = NonNullable<Awaited<ReturnType<typeof updateChecklist>>>
    export type UpdateChecklistMutationBody = BodyType<UpdateChecklistCommandBody>
    export type UpdateChecklistMutationError = ErrorType<unknown>

    export const useUpdateChecklist = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateChecklist>>, TError,{id: number;data: BodyType<UpdateChecklistCommandBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateChecklist>>,
        TError,
        {id: number;data: BodyType<UpdateChecklistCommandBody>},
        TContext
      > => {

      const mutationOptions = getUpdateChecklistMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const setDefaultChecklist = (
    id: number,
 options?: SecondParameter<typeof instance>,) => {
      
      
      return instance<SetDefaultChecklistCommandResponse>(
      {url: `/api/v1/hang-tag/check-list/${id}/default`, method: 'PUT'
    },
      options);
    }
  


export const getSetDefaultChecklistMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDefaultChecklist>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof setDefaultChecklist>>, TError,{id: number}, TContext> => {
    
const mutationKey = ['setDefaultChecklist'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setDefaultChecklist>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  setDefaultChecklist(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetDefaultChecklistMutationResult = NonNullable<Awaited<ReturnType<typeof setDefaultChecklist>>>
    
    export type SetDefaultChecklistMutationError = ErrorType<unknown>

    export const useSetDefaultChecklist = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDefaultChecklist>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof setDefaultChecklist>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getSetDefaultChecklistMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const cloneChecklist = (
    cloneChecklistCommandBody: BodyType<CloneChecklistCommandBody>,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<CloneChecklistCommandResponse>(
      {url: `/api/v1/hang-tag/check-list/clone`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cloneChecklistCommandBody, signal
    },
      options);
    }
  


export const getCloneChecklistMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cloneChecklist>>, TError,{data: BodyType<CloneChecklistCommandBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof cloneChecklist>>, TError,{data: BodyType<CloneChecklistCommandBody>}, TContext> => {
    
const mutationKey = ['cloneChecklist'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cloneChecklist>>, {data: BodyType<CloneChecklistCommandBody>}> = (props) => {
          const {data} = props ?? {};

          return  cloneChecklist(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CloneChecklistMutationResult = NonNullable<Awaited<ReturnType<typeof cloneChecklist>>>
    export type CloneChecklistMutationBody = BodyType<CloneChecklistCommandBody>
    export type CloneChecklistMutationError = ErrorType<unknown>

    export const useCloneChecklist = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cloneChecklist>>, TError,{data: BodyType<CloneChecklistCommandBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof cloneChecklist>>,
        TError,
        {data: BodyType<CloneChecklistCommandBody>},
        TContext
      > => {

      const mutationOptions = getCloneChecklistMutationOptions(options);

      return useMutation(mutationOptions);
    }
    